#import "../fragments/source-fragment.graphql"

query GetSources(
    $first: Int
    $after: String
    $hasChannel: Boolean
    $channel: ChannelType
    $sort: SourceSortType
) {
    sources(first: $first, after: $after, hasChannel: $hasChannel, channel: $channel, sort: $sort) {
        totalCount
        pageInfo {
            __typename
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...SourceFragment
            }
        }
    }
}
